import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-settings',
  templateUrl: './cookie-settings.component.html',
  styleUrls: ['./cookie-settings.component.css']
})
export class CookieSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    document.getElementById("id01").style.display = "block";
  }

}
